/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type DeploymentUpgradeStatusEnum = 'ALLOWED' | 'NOT_ALLOWED' | 'ON_HOLD';

export const DeploymentUpgradeStatusEnum = {

    ALLOWED: 'ALLOWED' as DeploymentUpgradeStatusEnum,

    NOT_ALLOWED: 'NOT_ALLOWED' as DeploymentUpgradeStatusEnum,

    ON_HOLD: 'ON_HOLD' as DeploymentUpgradeStatusEnum
};

